import {
  ActionSheet,
  Card,
  DialogProvider,
  Typography,
  useActionSheetProvider,
} from "@storoey/sui";
import { createSignal, For, Show } from "solid-js";
import { PhotoDto } from "../../backend/models/dto/Item.dto";
import { PhotoPickButtons } from "../../components/PhotoPickButtons/PhotoPickButtons";
import { PhotoViewer } from "../../components/PhotoViewer/PhotoViewer";
import { DialogProps } from "../../types/dialog.props";

export const PhotoDialog = (
  props: {
    photos: PhotoDto[] | null;
    onNewPhoto: (file: File) => void;
    onDelete: (id: PhotoDto["id"]) => void;
    onCleanup: () => void;
  } & DialogProps
) => {
  const actionSheet = useActionSheetProvider();
  const [photoId, setPhotoId] = createSignal<number | undefined>();

  const handleDelete = (id: number) => {
    setPhotoId(id);
    actionSheet.open();
  };

  return (
    <>
      <DialogProvider
        close={props.close}
        open={props.isOpen}
        onGone={props.onCleanup}
      >
        <DialogProvider.Content>
          <Show when={props.photos}>
            <Card>
              <Card.Content>
                <Card.Title>Bilder</Card.Title>
              </Card.Content>
              <Card.Actions>
                <Show when={props.photos?.length === 0}>
                  <Typography variant="c2">Ingen bilder</Typography>
                </Show>
                <For each={props.photos}>
                  {(photo) => (
                    <PhotoViewer
                      file={photo.file}
                      date={photo.date}
                      onDelete={() => handleDelete(photo.id)}
                      onClick={() => {}}
                    />
                  )}
                </For>
              </Card.Actions>
              <Card.Actions align="center">
                <PhotoPickButtons onPhoto={props.onNewPhoto} />
              </Card.Actions>
            </Card>
          </Show>
        </DialogProvider.Content>
      </DialogProvider>
      <ActionSheet isOpen={actionSheet.isOpen} close={actionSheet.close}>
        <ActionSheet.Content
          title="Er du sikker?"
          text="Denne handlingen kan ikke reverseres."
        >
          <ActionSheet.Button onClick={() => props.onDelete(photoId()!)} danger>
            Slett
          </ActionSheet.Button>
        </ActionSheet.Content>
      </ActionSheet>
    </>
  );
};
